import { gql } from "~/__generated__"

export const viewerSettingsQuery = gql(/* GraphQL */ `
  query ViewerSettings {
    viewer {
      id
      stripeAccountId
      stripeConnectReady
      stripeConnectRequirementsPending
      lettermemeSubscriptions {
        id
        stripeStatus
        lettermeme {
          id
          name
          urlPath
          subscriptionPriceCents
          subscriptionCurrency
        }
      }
      ownedLettermemes {
        id
        name
        monetizationEnabled
        subscriptionPriceCents
        subscriptionCurrency
      }
    }
  }
`)
